import { UpdateTicketResponse } from "../../../services/ticket";
import { GeneralCode, Interface } from "../../interface-definitions";

export type CommentDialogState = {
  commentDescription: string;
  selectedEvent: string;
  ifList: Interface;
  isShow: boolean;
  isSaved: boolean;
  formValidation: boolean;
  fieldPath: {
    cmnt: string;
  };
  onChangeSpreadsheetState: (
    newComment: string,
    updateTicketResponse: UpdateTicketResponse,
  ) => void;
};
export type PageNewState =
  | CommentDialogState
  | ((prevState: CommentDialogState) => CommentDialogState);
